export const ADMIN_LOGIN_PATH = "/studio-olive-cove";
